import { Column, Row } from '~components/table-view';

import { CarePlanServiceLine } from '~clients/models';

import ServiceLineActions from './ServiceLineActions';

const NOTES_SUMMARY_LENGTH = 80;

const summarise = (notes?: string | null): string => {
  if (!notes) return '—';
  return notes.length > NOTES_SUMMARY_LENGTH ? `${notes.slice(0, NOTES_SUMMARY_LENGTH).trimEnd()}…` : notes;
};

/**
 * Column definitions for the "List" view. Ids resolve to display names via the maps built
 * in ServicesDeliveryTab (falling back rather than crashing). The actions column delegates
 * to ServiceLineActions (type: 'custom') so this file stays JSX-free.
 */
const columnsFactory = (
  serviceTypesById: Map<number, string>,
  frequenciesById: Map<string, string>,
  goalLabelById: Map<string, string>,
  onEdit: (line: CarePlanServiceLine) => void,
  onDelete: (line: CarePlanServiceLine) => void,
  isSaving = false,
): Column[] => [
  {
    id: 'service',
    header: 'Service',
    type: 'text',
    deriveValue: (row) => serviceTypesById.get(row.ext_service_type_id) ?? `Service type #${row.ext_service_type_id}`,
  },
  {
    id: 'frequency',
    header: 'Frequency',
    type: 'text',
    deriveValue: (row) => (row.frequency_id ? frequenciesById.get(row.frequency_id) ?? '—' : '—'),
  },
  {
    id: 'linked_goal',
    header: 'Linked goal',
    type: 'text',
    deriveValue: (row) => (row.goal_id ? goalLabelById.get(row.goal_id) ?? 'Unknown goal' : 'Unlinked'),
  },
  {
    id: 'notes',
    header: 'Notes',
    type: 'text',
    deriveValue: (row) => summarise(row.notes),
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: ServiceLineActions,
    componentProps: (row: Row) => ({ line: row as CarePlanServiceLine, onEdit, onDelete, disabled: isSaving }),
  },
];

export default columnsFactory;
